module.exports = __webpack_public_path__ + "img/header-bg.ad924a4f.png";